import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/bullet/g5-bullet.png";
import type { Product } from "../../types";
import { physicalSecurityBullet } from "../product-list-groups/physicalSecurityBullet";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g5Bullet: Product = {
  id: "g5Bullet",
  productTitle: "G5 Bullet",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g5-bullet`,
  ],
  storePathParts: {
    productSlug: "uvc-g5-bullet",
    category: UniFiChildCategorySlug.CamerasBullet,
  },
  sku: "UVC-G5-Bullet",
  description: "g5Bullet.description",
  descriptionMaxWidth: 200,
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityBullet,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "translation",
        value: "g5Bullet.dimensions",
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: "5MP CMOS" },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g5Bullet.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "9 m (30 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.microphone" },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP55" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
